import QueryString from 'query-string';
import { useLocation } from 'react-router-dom';

export default function NavbarUrlManager(domain) {
  let location = useLocation();
  const queryString = QueryString.parse(location.search);
  const landingPage = document.location.pathname.startsWith('/landing/');
  const isHaven = queryString['haven'] === 'true';
  const isSms = queryString['sms'] === 'true';
  const isStandAlone = (isSms || isHaven) && landingPage;
  var url = '/';

  if (isStandAlone && isSms) {
    if (domain === 'navyfed.covrtech.com') {
      url = 'https://navyfedlandingpages.1clickcoverage.com/';
    }
    else if (domain === 'bbva.covrtech.com') {
      url = 'https://bbva.1clickcoverage.com/';
    }

  }

  return {
    url: url,
    isStandAlone: isStandAlone,
  };
}



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarUrlManager.js